module.exports = __webpack_public_path__ + "static/637856490-wide.4117b692.jpg";